module.exports = __webpack_public_path__ + "fonts/subset-Averta-Bold.2fe74ab.ttf";